import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { TemperatureService } from '../services/temperature.service';
import { Observable, Subscription } from 'rxjs';
import { ActivatedRoute, ParamMap } from '@angular/router';
import moment from 'moment';
import { TemperatureReadingModelHistory } from '../models/tempread-history-model';
import { ChartConfiguration, ChartType } from 'chart.js';
import { CrosshairPlugin } from 'chartjs-plugin-crosshair';


@Component({
    selector: 'app-temperaturehistory',
    templateUrl: './temperaturehistory.component.html',
    styleUrls: ['./temperaturehistory.component.css'],
    providers: [TemperatureService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TemperaturehistoryComponent implements OnInit, OnDestroy {
  sensorId: string;
  sensorIdSub: Subscription;

  historyHead: TemperatureReadingModelHistory;
  historyArr: Array<TemperatureReadingModelHistory>;

  public lineChartData: ChartConfiguration['data'] = {
    datasets: [],
    labels: []
  };

  constructor(
    private temperatureService: TemperatureService,
    private route: ActivatedRoute
  ) { }

  public lineChartType : ChartType = 'line';
  public chartPlugins = [CrosshairPlugin];
  public lineChartOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: 'index',
      intersect: false
    },
    scales: {
      x: {
        ticks: {
          display: true,
          maxTicksLimit: 12
        }
      },
      TEMP: {
        type: 'linear',
        position: 'right',
        display: true,
        ticks: {
          maxTicksLimit: 5
        }
      }
    },
    elements: {
      point: {
        radius: 0.2
      },
      line: {
        tension: 0.4
      }
    },
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        mode: 'index',
        intersect: false
      },
      crosshair: {
        line: {
          color: '#666',
          width: 1,
          dash: [5, 5]
        },
        snap: {
          enabled: true
        },
        zoom: {
          enabled: false
        }
      }
    }
  };

  // events
  public chartClicked(e: any): void {
  }

  public chartHovered(e: any): void {
  }

  ngOnInit() {
    // Create subscription to SensorID updates
    this.sensorIdSub = this.route.paramMap.subscribe((params: ParamMap) => {
      this.sensorId = String(params.get('id'));
      this.updateData();
    });
  }

  ngOnDestroy() {
    this.sensorIdSub.unsubscribe();
  }

  private updateData() {
    const dataArrTempAvg = new Array<number>();
    const dataArrTempMin = new Array<number>();
    const dataArrTempMax = new Array<number>();
    const labelArr = new Array<string>();

    // Do call to WIUP REST Service
    this.temperatureService.getHistoryForSensor(this.sensorId).subscribe(
      (data: Array<TemperatureReadingModelHistory>) => {
        this.historyArr = data;

        // Take first element of array and set to variable, used for getting Sensor name / description
        if (this.historyArr.length > 0) {
          this.historyHead = this.historyArr[0];
        }

        for (const element of this.historyArr.reverse()) {
          dataArrTempAvg.push(element.avgTemp);
          dataArrTempMin.push(element.minTemp);
          dataArrTempMax.push(element.maxTemp);
          labelArr.push(moment(element.sensorReadingDate).format('DD/MM-YY'));
        }

        this.lineChartData = {
          labels: labelArr,
          datasets: [
            {
              data: dataArrTempAvg,
              label: 'Avg temp',
              fill: 'origin',
              yAxisID: 'TEMP',
              backgroundColor: 'rgba(148,159,177,0.2)',
              borderColor: 'rgba(148,159,177,1)',
              pointBackgroundColor: 'rgba(148,159,177,1)',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: 'rgba(148,159,177,0.8)'
            },
            {
              data: dataArrTempMin,
              label: 'Min temp',
              fill: false,
              yAxisID: 'TEMP',
              backgroundColor: 'rgba(50,162,236,0.2)',
              borderColor: 'rgba(50,162,236,1)',
              pointBackgroundColor: 'rgba(148,159,177,1)',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: 'rgba(148,159,177,0.8)'
            },
            {
              data: dataArrTempMax,
              label: 'Max temp',
              fill: false,
              yAxisID: 'TEMP',
              backgroundColor: 'rgba(220,20,60,0.2)',
              borderColor: 'rgba(220,20,60,1)',
              pointBackgroundColor: 'rgba(148,159,177,1)',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: 'rgba(220,20,60,0.8)'
            }
          ]
        };
      },
      error => undefined
    );
  }
}
